import * as THREE from "three";
import ExtrudedLoopSubGeometry3d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry3d";
import AreaAnnotationData from "../sceneObjectData/AreaAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class AreaAnnotationGeometry3d extends ExtrudedLoopSubGeometry3d<AreaAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = AreaAnnotationGeometry3d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight)
            });
            mat.name = `AreaAnnotation3d-${getSceneObjectStyleName(style)}-Line`;
            AreaAnnotationGeometry3d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = AreaAnnotationGeometry3d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `AreaAnnotation3d-${getSceneObjectStyleName(style)}-Text`;
            AreaAnnotationGeometry3d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            AreaAnnotationGeometry3d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            AreaAnnotationGeometry3d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return AreaAnnotationGeometry3d.getLineMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return AreaAnnotationGeometry3d.getTextMaterial(style);
    }
}
